import { Company } from '@app/@core/data/models/company.model';
import { CompanyIntegrations } from '@app/@core/data/models/company-integrations.model';
import { createAction, props } from '@ngrx/store';

export enum CompanyActions {
  COMPANY_LOAD_COMPANY = '[Company] Load Company',
  COMPANY_LOAD_COMPANY_SUCCESS = '[Company] Load Company Success',

  COMPANY_LOAD_COMPANY_INTEGRATION = '[Company] Load Company Integration',
  COMPANY_LOAD_COMPANY_INTEGRATION_SUCCESS = '[Company] Load Company Integration Success',
}

export const loadCompany = createAction(
  CompanyActions.COMPANY_LOAD_COMPANY,
  props<{ name: string }>(),
);
export const loadCompanySuccess = createAction(
  CompanyActions.COMPANY_LOAD_COMPANY_SUCCESS,
  props<{ payload: { company: Company } }>(),
);

export const loadCompanyIntegration = createAction(
  CompanyActions.COMPANY_LOAD_COMPANY_INTEGRATION,
  props<{ name: string }>(),
);
export const loadCompanyIntegrationSuccess = createAction(
  CompanyActions.COMPANY_LOAD_COMPANY_INTEGRATION_SUCCESS,
  props<{ payload: { companyIntegration: CompanyIntegrations } }>(),
);